import React,{useState} from 'react';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { handleRemoteUrl } from '../../services/common/CommonUtils';
import { useQuery } from 'react-query';
import Loadingcomponent from '../loader/loadingcomponent';
import {
  setCarouselBannerBgColor,
  setCvmRecommendationsData,
  setHeaderTitleColor,
  setIsDefaultCarouselBanner,
  setShowNotificationGreetingSection,
} from '../../reducer/actions.js';
import { getCompleteRedirectUrl, redirecturl } from '../../services/common/redirect.js';
import { HTML5_FMT } from 'moment';
import shadowimage from '../../../src/shadowthemeimage.png';
import shadowimage_ar from '../../../src/shadowthemeimage_ar.png';
import { SELECTED_LANG } from "../../services/common/Constants.js";
import { getItemOfSessionStorage } from "../../services/common/utils.js";
import { setShowNotificationAndProfile } from '../../reducer/utilitySlice.js';
// import { themeDemoResData as data } from '../../utils/data.js';
const BannerCarouselTheme = ({ pmsitem }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [backGroundColor, setBackgroundColor] = useState("none")
  const { data: { data } = {}, isLoading,isFetching } = useQuery(
    ['banner-carousel', pmsitem?.method, JSON.parse(pmsitem?.sourceid), {}],
    {
      retry: false,
      retryOnMount: false,
      cacheTime: 0,
      staleTime: 0,
      onSuccess: ({ data }) => {
        dispatch(setCvmRecommendationsData(data));

        if (data?.response) {
          const offerList = data?.response
          .map((item) =>
            item.AvailableOffers.filter(
              (offer) => offer.recommendationflag === 'Y'
            ).map((offer) => ({ ...offer, msisdn: item?.msisdn }))
          )
          .flat();

          if(offerList.length > 0){
            // const firstCarouselData = data?.response[0]?.AvailableOffers?.find(
            //   (item) => item?.recommendationflag === 'Y'
            // );
            const firstCarouselData = offerList[0];
            console.log('firstCarouselData', firstCarouselData);
            const isDefault = firstCarouselData?.themedetails?.isdefault === 'T';
            const bgColor = firstCarouselData?.themedetails?.bgcolor || '';
            const headerTextColor =
              firstCarouselData?.themedetails?.headertintcolor || '';
              dispatch(setIsDefaultCarouselBanner(isDefault));
              dispatch(setCarouselBannerBgColor(bgColor));
              setBackgroundColor(bgColor);
              dispatch(setHeaderTitleColor(headerTextColor));
              dispatch(setShowNotificationGreetingSection(false));
            }else{
              dispatch(setShowNotificationAndProfile(true));
            }
        }else{
          dispatch(setShowNotificationAndProfile(true));
        }
      },
    }
  );

  const carouselData =
    data?.response &&
    data?.response
      .map((item) =>
        item.AvailableOffers.filter(
          (offer) => offer.recommendationflag === 'Y'
        ).map((offer) => ({ ...offer, msisdn: item?.msisdn }))
      )
      .flat();

  const handleSlideChange = (slideData) => {
    const bgColor = slideData?.themedetails?.bgcolor || '';
    const headerTextColor = slideData?.themedetails?.headertintcolor || '';
    dispatch(setCarouselBannerBgColor(bgColor));
    setBackgroundColor(bgColor);
    dispatch(setHeaderTitleColor(headerTextColor));
  };

  const handleBuyNow = (item) => {
    const isExternal = item?.themedetails?.buttonexternal !== 'F';
    const url = item?.themedetails?.buttonurl;
    // if(url?.indexOf("http") === 0){
    //   window.open(url, "_blank")
    // }
    // else if(url && url?.includes('bundleproductdetail')){
    //   const offercode = url.split('#')[1];
    //   navigate('/bundles', {
    //     state: {
    //       offercode: offercode,
    //     }
    //   })
    // }else{
    //   redirecturl(url, navigate, null, null, {
    //     offercode: item.offercode,
    //   });
    // }

    const navigateData = {
      offercode: item.offercode
    }

    if(url && url?.includes('bundleproductdetail')){
      const offercode = url.split('#')[1];
      if(offercode){
        navigate('/bundles', {
          state: {
            offercode: offercode,
            from: '/home'
          }
        });
      }else{
        navigate('/bundles');
      }
    }else{
      handleRemoteUrl(url, isExternal, navigate, navigateData);
    }

  };

  const handleLearnMore = (e, item) => {
    e.preventDefault();
    const isExternal = item?.themedetails?.learnmoreexternal !== 'F';
    const url = item?.themedetails?.learnmoreurl;
    // if(item?.themedetails?.learnmoreurl?.indexOf("http") === 0){
    //   window.open(item?.themedetails?.learnmoreurl, "_blank")
    // }
    // else if(item?.themedetails?.learnmoreurl) {
    //   redirecturl(item?.themedetails?.learnmoreurl, navigate);
    // } else {
    //   return;
    // }
    handleRemoteUrl(url, isExternal, navigate);
  };

  const getTheme = (item, index, backGroundColor) => {
    switch (item?.themedetails?.theme) {
      case 1:
        return (
          <ThemeOneCard
            item={item}
            handleLearnMore={handleLearnMore}
            handleBuyNow={handleBuyNow}
          />
        );
      case 2:
        return (
          <ThemeTwoCard
            item={item}
            handleLearnMore={handleLearnMore}
            handleBuyNow={handleBuyNow}
          />
        );
      case 3:
        return (
          <ThemeThreeCard
            item={item}
            handleLearnMore={handleLearnMore}
            handleBuyNow={handleBuyNow}
          />
        );
      case 4:
        return (
          <ThemeFourCard
            item={item}
            handleLearnMore={handleLearnMore}
            handleBuyNow={handleBuyNow}
            index={index}
            backGroundColor={backGroundColor}
          />
        );
      default:
        return <></>;
    }
  };

  if (isLoading || isFetching) {
    return <>
    <div class="dls13-theme-banner">
    <div class="swiper swiper-main-banner mb-5 scroll-pg-header" style={{background:'#e0e0e0'}}>
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="main-banner-comp">
                    <div class="main-banner-cont align-top">
                        <div class="bannercont-comp1 swiper-banner-hed">
                        <h5></h5>
                        {/* <div class="flex_grp_align_center flex-wrap d-flex">
                            <h5 class="primary_14 pack_name shimmerBG shimmer-p-text w-100 mb-2"></h5>
                        </div> */}
                        <p className='shimmerBG w-100 mb-2 shimmer-h25'></p>
                        
                            <div class="mainbanner-sliderheight">
                                <div class="package-row mt-3">
                                    <div class="me-2 package-price-sec">
                                        <div class="pakg-price shimmerBG shimmer-p-text p-2" style={{width:135}}></div>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-4 pt-2 d-flex">
                                <div class="balance_section_action">
                                    <button class="custom_btn custom_btn_sm custom_btn_primary shimmerBG shimmer-button-md">
                                        
                                    </button>
                                </div>
                                <a href="" class="hyperlink_white btn_block ms-3">
                                    <label class="shimmerBG shimmer-p-text p-2" style={{width:120}}></label>
                                </a>
                            </div>
                        </div>
                        <div class="bannercont-comp2 shimmer-h25">
                          {

                          getItemOfSessionStorage(SELECTED_LANG) === 'en' ?                      
                          <img src={shadowimage} alt="" title="" class="right-img" /> : 
                          <img src={shadowimage_ar} alt="" title="" class="" />
                        }
                        </div>
                    </div>
                </div>
            </div>
       </div>
        <div class="swiper-pagination"></div>
    </div>
</div>
         </>
  }

  if (!data?.response || carouselData?.length === 0) {
    return <></>;
  }
  console.log('carouselData', carouselData);
  return (
    <>
   <div className='dls13-theme-banner'>
    <div class="swiper-main-banner mb-5 scroll-pg-header"
         id="transistion"
        //  style={{ background: backGroundColor }}
         >
        <Swiper modules={[Pagination]}
                pagination={{ clickable: true }}
                className="swiper-main-banner"
                // style={{ background: 'none' }}
                onSlideChange={(swiperData) =>
            {
              const videos = document.querySelectorAll('video');
              console.log('videos==>', videos);
              
              for(let video of videos){
                console.log('video==>', video);
                if(video.id !== `${`videoId-${swiperData?.activeIndex}`}`){
                  video?.pause();
                }
              }

              console.log('swiperData==>', swiperData);
              const data = swiperData?.activeIndex;
              handleSlideChange(carouselData[data]);

              const video = document.getElementById(`videoId-${swiperData?.activeIndex}`);
              if(!video) return;
              video.controls = false;
              video.allowfullscreen = false;
              video.currentTime = 0;
              video?.play()
            }}
            onInit={(swiperData) => {
              const data = carouselData[swiperData?.activeIndex];
              // console.log('see==>', demo, data);
              if(data?.themedetails?.theme === 4){
                const video = document.getElementById(`videoId-${swiperData?.activeIndex}`);
                if(!video) return;
                video.controls = false;
                video.allowfullscreen = false;
                video.currentTime = 0;
                video?.play()
              }
            }}
            >
            {carouselData?.slice(0, data?.recommendationcount).map((item, index) => {
              const isVideoTheme = item?.themedetails?.theme === 4 ? true : false;
            return (
            <SwiperSlide style={{ background: isVideoTheme ? '' : backGroundColor }}>
                {/* <div class="main-banner-comp">
                    <div class="main-banner-cont align-top">
                        <div class="bannercont-comp1 swiper-banner-hed">
                            <h6 style={{ color: item?.themedetails?.titlefgcolor }}> {item?.themedetails?.themetitle} </h6>
                            <p style={{ color: item?.themedetails?.themedesccolor }}>{item?.description}</p>
                            {item?.showquota === 'T' ? (
                            <div class="mainbanner-sliderheight">
                                {item?.themedetails?.quotatypes?.map(
                                (quota, index, arr) => {
                                return (
                                <>
                                <div class="package-row">
                                    <div class="packg-comp">{quota?.value}</div>
                                    <div class="packg-sup-text">
                                        {quota?.key}
                                    </div>
                                </div>
                                {arr?.length > index + 1 && (
                                <div>
                                    <label> + </label>
                                </div>
                                )}
                                </>
                                );
                                }
                                )}
                            </div>
                            ) : (
                            <div class="mainbanner-sliderheight">
                                <div className="package-row">
                                    <div className="me-2 package-price-sec">
                                        {item?.discountedprice > 0 && (
                                        <div className="pakg-old me-2 text-line-through">
                                            {item?.currency} {item?.amount}
                                        </div>
                                        )}
                                        <div className="pakg-price">
                                            {item?.currency}
                                            <label>
                                                {item?.discountedprice > 0
                                                ? item?.discountedprice
                                                : item?.amount}
                                            </label>
                                            {item?.validity ? `/${item?.validity}` : ''}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )}

                            <div class="mt-4 pt-2 d-flex">
                                <div class="balance_section_action">
                                    <button class="custom_btn custom_btn_sm custom_btn_primary"
                                            style={{
                              backgroundColor:
                                item?.themedetails?.buttonbgcolor,
                              color: item?.themedetails?.buttontitlecolor,
                            }}
                                            onClick={() =>
                                        handleBuyNow(item)}
                                        >
                                        {item?.themedetails?.buttontext}
                                    </button>
                                </div>
                                <a href=""
                                   class="hyperlink_white btn_block ms-3"
                                   style={{
                            color: item?.themedetails?.learnmoretextcolor,
                          }}
                                   onClick={(e) =>
                                    handleLearnMore(e, item)}
                                    >
                                    {item?.themedetails?.learnmoretext}{' '}
                                    <img src={getImgSrc(
                                         '/assets/images/icon/arrow_right_white.svg'
                                         )}
                                         class="ms-1"
                                         alt="" />
                                </a>
                            </div>
                        </div>
                        <div class="bannercont-comp2">
                            <img src={item?.themedetails?.themeimage}
                                 alt=""
                                 title=""
                                 class="right-img" />
                        </div>
                    </div>
                </div> */}
                {getTheme(item, index, backGroundColor)}
            </SwiperSlide>
            );
            })}
        </Swiper>
    </div>
</div>
     
    </>
  );
};

export default BannerCarouselTheme;

/**
 * Theme one card component (for title, desc, benifits and cta buttons)
 * @returns {JSX}
 */
const ThemeOneCard = ({ item, handleLearnMore, handleBuyNow }) => {
  const isDefault = item?.themedetails?.isdefault === 'T';

  return (
    <div class="main-banner-comp">
      <div class="main-banner-cont align-top w-100">
        <div class="bannercont-comp1 swiper-banner-hed w-65">
          {item?.themedetails?.themetitle?.length > 0 ? (
            <h5 style={{ color: item?.themedetails?.titlefgcolor }}>
              {item?.themedetails?.themetitle}
            </h5>
          ) : (
            <h6>&nbsp;</h6>
          )}

          <p
            // style={{
            //   color: isDefault
            //     ? item?.themedetails?.themedesccolor
            //     : item?.themedetails?.fgcolor,
            // }}
            style={{ color: item?.themedetails?.fgcolor }}
          >
            {/* {isDefault
              ? item?.themedetails?.themedesc || ''
              : item?.description || ''} */}
               { item?.description }
          </p>
          {item?.showquota === 'T' ? (
            <div
              class="mainbanner-sliderheight"
              // style={{
              //   color: isDefault
              //     ? item?.themedetails?.themedesccolor
              //     : item?.themedetails?.fgcolor,
              // }}
              style={{ color: item?.themedetails?.fgcolor }}
            >
              {item?.themedetails?.quotatypes?.map((quota, index, arr) => {
                return (
                  // <>
                  //   <div class="package-row text-color-inherit">
                  //     <div class="packg-comp">{quota?.value}</div>
                  //     <div class="packg-sup-text">{quota?.key}</div>
                  //   </div>
                  //   {arr?.length > index + 1 && (
                  //     <div>
                  //       <label> + </label>
                  //     </div>
                  //   )}
                  // </>
                  <div className="package-row text-color-inherit mt-2">
                    <div
                      className="packg-comp me-2"
                      // style={{
                      //   borderColor: isDefault
                      //     ? item?.themedetails?.themedesccolor
                      //     : item?.themedetails?.fgcolor,
                      // }}
                      style={{ borderColor: item?.themedetails?.fgcolor }}
                    >
                      {quota?.value}
                    </div>
                    {quota?.key}
                  </div>
                );
              })}
            </div>
          ) : (
            <></>
          )}

          <div class="mt-4 pt-2 d-flex main-banner-action-comp">
            <div class="balance_section_action">
              <button
                class="custom_btn custom_btn_sm text-initials"
                style={{
                  borderColor: item?.themedetails?.buttonbgcolor,
                  backgroundColor: item?.themedetails?.buttonbgcolor,
                  color: item?.themedetails?.buttontitlecolor,
                }}
                onClick={() => handleBuyNow(item)}
              >
                {item?.themedetails?.buttontext}
              </button>
            </div>
            {
              item?.themedetails?.learnmoretext && (
            <a
              href=""
              class="hyperlink_white btn_block ms-3"
              style={{
                color: item?.themedetails?.learnmoretextcolor,
              }}
              onClick={(e) => handleLearnMore(e, item)}
            >
              {item?.themedetails?.learnmoretext}{' '}
              {/* <img
                src={getImgSrc('/assets/images/icon/arrow_right_white.svg')}
                class="ms-1"
                alt=""
              /> */}
              <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 20" height="14" width="14">
                <defs>
                <clipPath id="clip-path">
                <rect id="Rectangle_63402" data-name="Rectangle 63402" width="20" height="20" transform="translate(-19298 16940)" fill="#fff"></rect>
                </clipPath>
                </defs>
                <g id="Mask_Group_8040" data-name="Mask Group 8040" transform="translate(-16940 -19278) rotate(-90)" clip-path="url(#clip-path)">
                <path id="Path_2" data-name="Path 2" d="M0,0,5.934,6.589,0,13.179" transform="translate(-19281.32 16947.5) rotate(90)" fill="none" stroke={item?.themedetails?.learnmoretextcolor} stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                </g>
              </svg>
            </a>
              )
            }
          </div>
        </div>
        <div class="bannercont-comp2">
          <img
            src={item?.themedetails?.themeimage}
            alt=""
            title=""
            class="right-img"
          />
        </div>
      </div>
    </div>
  );
};

/**
 * Theme two card component (for title, desc, price and cta buttons)
 * @returns {JSX}
 */
const ThemeTwoCard = ({ item, handleLearnMore, handleBuyNow }) => {
  const isDefault = item?.themedetails?.isdefault === 'T';

  return (
    <div class="main-banner-comp">
      <div class="main-banner-cont align-top w-100">
        <div class="bannercont-comp1 swiper-banner-hed w-65">
          <h5 style={{ color: item?.themedetails?.titlefgcolor }}>
            {item?.themedetails?.themetitle}
          </h5>
          <p
            // style={{
            //   color: isDefault
            //     ? item?.themedetails?.themedesccolor
            //     : item?.themedetails?.fgcolor,
            // }}
            style={{ color: item?.themedetails?.fgcolor }}
          >
            {/* {isDefault
              ? item?.themedetails?.themedesc || ''
              : item?.description || ''} */}
            {item?.description}
          </p>
          <div class="mainbanner-sliderheight">
            <div className="package-row">
              <div className="me-2 package-price-sec">
                {item?.discountedprice > 0 && (
                  <div className="pakg-old me-2 text-line-through mb-0" style={{color: item?.themedetails?.discountpricetextcolor || '' }}>
                    {item?.currency + " "} {item?.amount}
                  </div>
                )}
                <div className="pakg-price" style={{color: item?.themedetails?.offerpricetextcolor || '' }}>
                  {item?.currency + " "} 
                    {item?.discountedprice > 0
                      ? item?.discountedprice
                      : item?.amount}
                  {item?.validity ? `/${item?.validity}` : ''}
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4 pt-2 d-flex main-banner-action-comp">
            <div class="balance_section_action">
              <button
                class="custom_btn custom_btn_sm text-initials"
                style={{
                  borderColor: item?.themedetails?.buttonbgcolor,
                  backgroundColor: item?.themedetails?.buttonbgcolor,
                  color: item?.themedetails?.buttontitlecolor,
                }}
                onClick={() => handleBuyNow(item)}
              >
                {item?.themedetails?.buttontext}
              </button>
            </div>
            {
              item?.themedetails?.learnmoretext && (
            <a
              href=""
              class="hyperlink_white btn_block ms-3"
              style={{
                color: item?.themedetails?.learnmoretextcolor,
              }}
              onClick={(e) => handleLearnMore(e, item)}
            >
              {item?.themedetails?.learnmoretext}{' '}
              {/* <img
                src={getImgSrc('/assets/images/icon/arrow_right_white.svg')}
                class="ms-1"
                alt=""
              /> */}
              <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 20" height="14" width="14">
                <defs>
                <clipPath id="clip-path">
                <rect id="Rectangle_63402" data-name="Rectangle 63402" width="20" height="20" transform="translate(-19298 16940)" fill="#fff"></rect>
                </clipPath>
                </defs>
                <g id="Mask_Group_8040" data-name="Mask Group 8040" transform="translate(-16940 -19278) rotate(-90)" clip-path="url(#clip-path)">
                <path id="Path_2" data-name="Path 2" d="M0,0,5.934,6.589,0,13.179" transform="translate(-19281.32 16947.5) rotate(90)" fill="none" stroke={item?.themedetails?.learnmoretextcolor} stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                </g>
              </svg>
            </a>
              )
            }
          </div>
        </div>
        <div class="bannercont-comp2">
          <img
            src={item?.themedetails?.themeimage}
            alt=""
            title=""
            class="right-img"
          />
        </div>
      </div>
    </div>
  );
};

/**
 * Theme three card component (for desc and cta buttons)
 * @returns {JSX}
 */
const ThemeThreeCard = ({ item, handleLearnMore, handleBuyNow }) => {
  const isDefault = item?.themedetails?.isdefault === 'T';

  return (
    <div class="main-banner-comp">
      <div class="main-banner-cont align-top w-100">
        <div class="bannercont-comp1 swiper-banner-hed w-65">
          <h6></h6>
          <p
            // style={{
            //   color: isDefault
            //     ? item?.themedetails?.themedesccolor
            //     : item?.themedetails?.fgcolor,
            // }}
            style={{ color: item?.themedetails?.fgcolor }}
          >
            {/* {isDefault
              ? item?.themedetails?.themedesc || ''
              : item?.description || ''} */}
            { item?.description }
          </p>
          <div class="mt-4 pt-2 d-flex main-banner-action-comp">
            <div class="balance_section_action">
              <button
                class="custom_btn custom_btn_sm text-initials"
                style={{
                  borderColor: item?.themedetails?.buttonbgcolor,
                  backgroundColor: item?.themedetails?.buttonbgcolor,
                  color: item?.themedetails?.buttontitlecolor,
                }}
                onClick={() => handleBuyNow(item)}
              >
                {item?.themedetails?.buttontext}
              </button>
            </div>
            {
              item?.themedetails?.learnmoretext && (

            <a
              href=""
              class="hyperlink_white btn_block ms-3"
              style={{
                color: item?.themedetails?.learnmoretextcolor,
              }}
              onClick={(e) => handleLearnMore(e, item)}
            >
              {item?.themedetails?.learnmoretext}{' '}
              {/* <img
                src={getImgSrc('/assets/images/icon/arrow_right_white.svg')}
                class="ms-1"
                alt=""
              /> */}
              <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 20" height="14" width="14">
                <defs>
                <clipPath id="clip-path">
                <rect id="Rectangle_63402" data-name="Rectangle 63402" width="20" height="20" transform="translate(-19298 16940)" fill="#fff"></rect>
                </clipPath>
                </defs>
                <g id="Mask_Group_8040" data-name="Mask Group 8040" transform="translate(-16940 -19278) rotate(-90)" clip-path="url(#clip-path)">
                <path id="Path_2" data-name="Path 2" d="M0,0,5.934,6.589,0,13.179" transform="translate(-19281.32 16947.5) rotate(90)" fill="none" stroke={item?.themedetails?.learnmoretextcolor} stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                </g>
              </svg>
            </a>
              )
            }
          </div>
        </div>
        <div class="bannercont-comp2">
          <img
            src={item?.themedetails?.themeimage}
            alt=""
            title=""
            class="right-img"
          />
        </div>
      </div>
    </div>
  );
};

/**
 * Theme Four card component (theme with video)
 * @returns {JSX}
 */
const ThemeFourCard = ({ item, handleLearnMore, handleBuyNow, index, backGroundColor }) => {
  const isDefault = item?.themedetails?.isdefault === 'T';

  return (
    <>
    <div className='sp16-main-video-banner'>
    <div className="main-banner-comp">
      <div class="main-banner-cont align-top w-100">
        <div class="bannercont-comp1 swiper-banner-hed w-65">
          <h5 style={{ color: item?.themedetails?.titlefgcolor }}>
            {item?.themedetails?.themetitle}
          </h5>
          <p
            // style={{
            //   color: isDefault
            //     ? item?.themedetails?.themedesccolor
            //     : item?.themedetails?.fgcolor,
            // }}
            style={{ color: item?.themedetails?.fgcolor }}
          >
            {/* {isDefault
              ? item?.themedetails?.themedesc || ''
              : item?.description || ''} */}
            {item?.description}
          </p>
          <div class="mainbanner-sliderheight">
            <div className="package-row">
              <div className="me-2 package-price-sec">
                {item?.discountedprice > 0 && (
                  <div className="pakg-old me-2 text-line-through mb-0">
                    {item?.currency + " "} {item?.amount}
                  </div>
                )}
                <div className="pakg-price" style={{color: item?.themedetails?.offerpricetextcolor || '' }}>
                  {item?.currency + " "} 
                    {item?.discountedprice > 0
                      ? item?.discountedprice
                      : item?.amount}
                  {item?.validity ? `/${item?.validity}` : ''}
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4 pt-2 d-flex main-banner-action-comp">
            <div class="balance_section_action">
              {
                item?.themedetails?.buttontext && (
                  <button
                    class="custom_btn custom_btn_sm text-initials"
                    style={{
                      borderColor: item?.themedetails?.buttonbgcolor,
                      backgroundColor: item?.themedetails?.buttonbgcolor,
                      color: item?.themedetails?.buttontitlecolor,
                    }}
                    onClick={() => handleBuyNow(item)}
                  >
                    {item?.themedetails?.buttontext}
                  </button>
                )
              }
              
            </div>
            {
              item?.themedetails?.learnmoretext && (
            <a
              href=""
              class="hyperlink_white btn_block ms-3"
              style={{
                color: item?.themedetails?.learnmoretextcolor,
              }}
              onClick={(e) => handleLearnMore(e, item)}
            >
              {item?.themedetails?.learnmoretext}{' '}
              {/* <img
                src={getImgSrc('/assets/images/icon/arrow_right_white.svg')}
                class="ms-1"
                alt=""
              /> */}
              {/* <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 20" height="14" width="14">
                <defs>
                <clipPath id="clip-path">
                <rect id="Rectangle_63402" data-name="Rectangle 63402" width="20" height="20" transform="translate(-19298 16940)" fill="#fff"></rect>
                </clipPath>
                </defs>
                <g id="Mask_Group_8040" data-name="Mask Group 8040" transform="translate(-16940 -19278) rotate(-90)" clip-path="url(#clip-path)">
                <path id="Path_2" data-name="Path 2" d="M0,0,5.934,6.589,0,13.179" transform="translate(-19281.32 16947.5) rotate(90)" fill="none" stroke={item?.themedetails?.learnmoretextcolor} stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                </g>
              </svg> */}
            </a>
              )
            }
          </div>
        </div>
        {/* <div class="bannercont-comp2">
          <img
            src={item?.themedetails?.themeimage}
            alt=""
            title=""
            class="right-img"
          />
        </div> */}
      </div>
    </div>
    <video 
    id={`videoId-${index}`} 
    autoplay 
    muted 
    loop 
    height={'100%'} 
    width={'500px'} 
    // controls="false"
    controls={false} 
    allowFullScreen={false}
    playsInline
    preload="metadata"
    // style={{marginLeft: '-1.5rem'}} 
    >
        <source 
        src={item?.themedetails?.video_url}
        // src={item?.themedetails?.video_url || (process.env.PUBLIC_URL + '/assets/images/sprint16-json/Bg-video.mp4')}        
        type="video/mp4" />
    </video>
    {/* <div className='main-banner-over-bg' style={{background: backGroundColor ? backGroundColor : 'none'}}>

    </div> */}

    </div>
    </>
  );
};
